// components/Common/DeletionWarningBanner.jsx
import React from "react";
import { FiAlertTriangle, FiX } from "react-icons/fi";
import "./DeletionWarningBanner.css";

/**
 * warnings: array of SubGroupDeletionResult-shaped objects
 *   { subGroupName, affectedScenarios: [{ scenarioName, affectedSectionNames: [] }] }
 */
const DeletionWarningBanner = ({ warnings, onDismiss }) => {
    if (!warnings || warnings.length === 0) return null;

    return (
        <div className="deletion-warning-banner">
            <div className="deletion-warning-header">
                <FiAlertTriangle className="deletion-warning-icon" />
                <span className="deletion-warning-title">
                    {warnings.length === 1
                        ? "Removed from scenario(s)"
                        : `Removed from scenario(s) for ${warnings.length} article(s)`}
                </span>
                <button
                    type="button"
                    className="deletion-warning-close"
                    onClick={onDismiss}
                    title="Dismiss"
                >
                    <FiX />
                </button>
            </div>

            <ul className="deletion-warning-list">
                {warnings.map((w) => (
                    <li key={w.subGroupName} className="deletion-warning-item">
                        <strong>{w.subGroupName}</strong>
                        <ul className="deletion-warning-scenarios">
                            {w.affectedScenarios.map((s) => (
                                <li key={s.scenarioName}>
                                    {s.scenarioName}: {s.affectedSectionNames.join(", ")}
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default DeletionWarningBanner;